import type { Activity } from '@user/features/Activity'
import { isAPIError, put } from '@user/store/services/crud'
import { urls } from '@user/features/Activity'
import { toast } from '@sales-center/components'
import { updateActivityActionCreator } from '@user/features/Activity/state'
import { type Actions } from '../state'

export async function updateActivityBulkEffect(
  activity: Activity,
): Promise<Actions | undefined> {
  const response = await put(urls.upsertBulk, activity)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to update Activity')
    }

    return updateActivityActionCreator()
  }

  return updateActivityActionCreator(result)
}
